import { Modal } from "bootstrap";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { EventEmitterMixin } from "widgets-module/mixins/event-emitter.mixin";

export class NotificationModalComponent extends EventEmitterMixin(EmptyInstance) {
    public static readonly SELECTOR = ".js-pcg-notification-modal";
    public static readonly REMOVE_EVENT = "notification-modal/remove";

    private _modal: Modal | null = null; // we use bootstrap.Modal as workaround for cookiebot issue to fix bug ".modal(...) is not a function"
    private _currentContext: JQuery | null = null;
    private _displayDelayInMilliseconds: number = 0;

    private _id: string = "";
    public get id(): string {
        return this._id;
    }

    public show(): void {
        setTimeout(() => this._modal!.show(), this._displayDelayInMilliseconds);
        // setTimeout(() => this._currentContext.modal("show"), this._displayDelayInMilliseconds);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
    public destroy = (): void => this.complete(NotificationModalComponent.REMOVE_EVENT);

    private bindEvents(): void {
        this._currentContext!.on("hide.bs.modal", () => {
            this.emit(NotificationModalComponent.REMOVE_EVENT, this);
        });
    }

    private parseContext(): void {
        this._modal = new Modal(this._currentContext![0], {} as Partial<Modal.Options>);
        // this._id = this._currentContext[0].id;
        this._id = this._currentContext!.data("id") as string;
    }

    public init(context: JQuery, displayDelayInMilliseconds: number): void {
        this._currentContext = context || this._currentContext;
        this._displayDelayInMilliseconds = displayDelayInMilliseconds || this._displayDelayInMilliseconds;

        this.parseContext();
        this.bindEvents();
    }
}
